import React from "react";
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import HomeIcon from '@mui/icons-material/Home';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import RuleIcon from '@mui/icons-material/Rule';
import SmsIcon from '@mui/icons-material/Sms';
import { FindAcceptances } from "../views/FindAcceptances";
import { Home } from "../views/Home";
import { ManageQrCodes } from "../views/ManageQrCodes";
import { ManageSmsTemplates } from "../views/ManageSmsTemplates";
import { SearchRules } from "../views/SearchRules";
import { ViewRules } from "../views/ViewRules";
import { Environments } from "./Environments";
import { UploadRules } from "../views/UploadRules";


export type ViewProps = {
    
    canBeSeenInReadonlyMode: boolean;
    element: React.ReactNode;
    icon?: React.ReactElement;
    index: number;
    isTopLevel: boolean;
    path: string;
    text?: string;

}

const views: ViewProps[] = [
    
    {
        
        canBeSeenInReadonlyMode: true,
        element: <Home />,
        icon: <HomeIcon/>,
        index: 0,
        isTopLevel: true,
        path: '/',
        text: 'Home'

    },
    {
       
        canBeSeenInReadonlyMode: true,
        element: <SearchRules />,
        icon: <ManageSearchIcon/>,
        index: 1,
        isTopLevel: true,
        path: '/search-rules',
        text: 'Search Rules'

    },
    {
        
        canBeSeenInReadonlyMode: false,
        element: <UploadRules />,
        icon: <RuleIcon/>,
        index: 2,
        isTopLevel: true,
        path: '/upload-rules',
        text: 'Upload Rules'

    },
    {
       
        canBeSeenInReadonlyMode: true,
        element: <FindAcceptances />,
        icon: <ContentPasteSearchIcon/>,
        index: 3,
        isTopLevel: true,
        path: '/find-acceptances',
        text: 'Find Acceptances'

    },
    {
        
        canBeSeenInReadonlyMode: true,
        element: <ViewRules />,
        index: 6,
        isTopLevel: false,
        path: '/view-rules/:id'

    },

];


if( process.env.REACT_APP_ENVIRONMENT !== Environments.PRD ) {

    views.push(

        {
        
            canBeSeenInReadonlyMode: true,
            element: <ManageQrCodes />,
            icon: <QrCode2Icon/>,
            index: 5,
            isTopLevel: true,
            path: '/manage-qr-codes',
            text: 'Manage QR Codes'
    
        },
    
    );

    views.push(

        {
        
            canBeSeenInReadonlyMode: false,
            element: <ManageSmsTemplates />,
            icon: <SmsIcon/>,
            index: 4,
            isTopLevel: true,
            path: '/manage-sms-templates',
            text: 'Manage SMS Templates'
    
        },

    );

}



export default views;